const sizesMap = {
    sm: 'sm',
    smd: 'smd',
    md: 'md',
    lg: 'lg',
    full: 'full'
}

export const defaultSize = 'md'

export const sizes = Object.keys(sizesMap)

export default sizesMap
